import axios from './axios';
import config from '../../helpers/config';

export default (email, designId, orderTotal, brand, productImageUrl, productName) => (
  axios.post(
    config.designBuilderSendSavedDesignEmail,
    {
      To: email,
      DesignId: designId,
      AdditionalParameters: {
        OrderTotal: orderTotal,
        Brand: brand,
        ProductImageUrl: productImageUrl,
        ProductName: productName,
      },
    },
  )
);
